import { supabase } from '../../providers/supabase/client';

export interface DestinationTransferItem {
  id?: number;
  created_at?: string;
  place_id: number;
  route_type: string;
  route_name: string;
  transfer_mode: string;
  price_per_person: number;
  provider_id?: number | null;
  notes?: string | null;
  is_active?: boolean;
  places?: { id: number; name: string; country?: string } | null;
  providers?: { id: number; name: string } | null;
}

export const fetchDestinationTransfers = async (): Promise<DestinationTransferItem[]> => {
  const { data, error } = await supabase
    .from('destination_transfers')
    .select(`
      *,
      places ( id, name, country ),
      providers ( id, name )
    `)
    .order('id', { ascending: false });

  if (error) {
    console.error('Error fetching destination transfers:', error);
    throw error;
  }
  return data || [];
};

export const createDestinationTransfer = async (transfer: Omit<DestinationTransferItem, 'id' | 'created_at'>): Promise<DestinationTransferItem> => {
  const { data, error } = await supabase
    .from('destination_transfers')
    .insert([transfer])
    .select(`
      *,
      places ( id, name, country ),
      providers ( id, name )
    `)
    .single();

  if (error) {
    console.error('Error creating destination transfer:', error);
    throw error;
  }
  return data;
};

export const updateDestinationTransfer = async (id: number, transfer: Partial<DestinationTransferItem>): Promise<DestinationTransferItem> => {
  const { data, error } = await supabase
    .from('destination_transfers')
    .update(transfer)
    .eq('id', id)
    .select(`
      *,
      places ( id, name, country ),
      providers ( id, name )
    `)
    .single();

  if (error) {
    console.error('Error updating destination transfer:', error);
    throw error;
  }
  return data;
};

export const deleteDestinationTransfer = async (id: number): Promise<void> => {
  const { error } = await supabase
    .from('destination_transfers')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Error deleting destination transfer:', error);
    throw error;
  }
};

export const upsertDestinationTransfer = async (transfer: Omit<DestinationTransferItem, 'created_at'>): Promise<DestinationTransferItem> => {
  const { data, error } = await supabase
    .from('destination_transfers')
    .upsert([transfer], { onConflict: 'place_id,provider_id,route_type,transfer_mode' })
    .select(`
      *,
      places ( id, name, country ),
      providers ( id, name )
    `)
    .single();

  if (error) {
    console.error('Error upserting destination transfer:', error);
    throw error;
  }
  return data;
};
